import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar/Sidebar'
import AdminNavbar from '../AdminNavbar/AdminNavbar'
import "./logout.css"
import block from "../../Image/blockchain.png"
import app from "../../Image/adventureApp.png"
import project from "../../Image/project.png"
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from 'react-router-dom';
const apiUrl = process.env.REACT_APP_API_BASE_URL;

function Logout() {

  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    expertise: '',
    username: '',
    education: '',
    organization: '',
    workHistory: '',
    languages: '',
    birthday: '',
    address: '',
    aboutInfo: '',
    profileImage: null
  });

  const [projects, setProjects] = useState([]);

  const [errors, setErrors] = useState({});

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
      
        const response = await mockFetchUserData();
        setUserData(response.userData);
        setProjects(response.projects);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

 
  const mockFetchUserData = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          userData: {
            firstName: 'John',
            lastName: 'Doe',
            email: 'john.doe@example.com',
            password: 'securePassword123',
            expertise: 'Web Development',
            username: 'johndoe',
            education: 'Computer Science, MIT',
            organization: 'Tech Innovations Inc.',
            workHistory: '5+ years in software development',
            languages: 'English, Spanish, JavaScript',
            birthday: '1990-05-15',
            address: '123 Tech Street, Silicon Valley',
            aboutInfo: 'Passionate developer with expertise in React, Node.js, and cloud technologies.',
            profileImage: 'https://via.placeholder.com/150'
          },
          projects: [
            {
              id: 1,
              title: 'Technology behind the Blockchain',
              image: block,
              details: 'A comprehensive study of blockchain technology and its applications.'
            },
            {
              id: 2,
              title: 'Task Based Adventure App',
              image: app,
              details: 'Gamified task management application with adventure elements.'
            },
            {
              id: 3,
              title: 'Data Visualization Project',
              image: project,
              details: 'Interactive data visualization dashboard for business analytics.'
            }
          ]
        });
      }, 500);
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUserData(prevData => ({
          ...prevData,
          profileImage: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!userData.firstName) newErrors.firstName = 'First name is required';
    if (!userData.email) newErrors.email = 'Email is required';

    if (Object.keys(newErrors).length === 0) {
      console.log('Form submitted:', userData);
      alert('Profile updated successfully!');
    } else {
      setErrors(newErrors);
    }
  };


  const handleLogout = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        localStorage.removeItem('token');
        navigate('/');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };
  return (
    <>
      <div class='main-dashboard'>
        <div>
          <Sidebar />
        </div>

        <div className="dashboard">
          <AdminNavbar />
          <div className="profile-page-container">
            <div className="profile-section">
              <h2 className='my-logout'>My Account <span className="hand-icon">✋</span></h2>

              <form onSubmit={handleSubmit}>
                <h3>Generals</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={userData.firstName}
                      onChange={handleInputChange}
                      className={errors.firstName ? 'error' : ''}
                    />
                    {errors.firstName && <span className="error-message">{errors.firstName}</span>}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={userData.lastName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={userData.email}
                      onChange={handleInputChange}
                      className={errors.email ? 'error' : ''}
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>

                  <div className="form-group password-field">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      value={userData.password}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <EyeOff /> : <Eye />}
                    </button>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="expertise"
                      placeholder="Expertise"
                      value={userData.expertise}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="username"
                      placeholder="Username"
                      value={userData.username}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="profile-image-section">
                  <div className="profile-image-label">Profile Image</div>
                  <div className="profile-image-container">
                    <img
                      src={userData.profileImage || '/images/default-profile.jpg'}
                      alt="Profile"
                      className="profile-image"
                    />
                    <button type="button" className="choose-image-btn" onClick={() => document.getElementById('imageUpload').click()}>
                      Choose Image
                    </button>
                    <input
                      id="imageUpload"
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleImageUpload}
                    />
                  </div>
                </div>

                <h3>Other Information</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <input
                      type="text"
                      name="education"
                      placeholder="Education"
                      value={userData.education}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="organization"
                      placeholder="Organization"
                      value={userData.organization}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="workHistory"
                      placeholder="Work History"
                      value={userData.workHistory}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="languages"
                      placeholder="Languages"
                      value={userData.languages}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="date"
                      name="birthday"
                      placeholder="Birthday"
                      value={userData.birthday}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={userData.address}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group full-width">
                    <textarea
                      name="aboutInfo"
                      placeholder="About Info"
                      value={userData.aboutInfo}
                      onChange={handleInputChange}
                      rows="4"
                    ></textarea>
                  </div>
                </div>

                <div className="button-group">
                <div className="button-group">
                <button type="button" className="logout-btn" onClick={handleLogout}>Logout</button>
              </div>
                  <button type="submit" className="save-btn">Save Changes</button>
                </div>
              </form>
            </div>




            <div className="sidebar-section">
              <div className="upload-section">
                <h3>Complete your profile</h3>
                <p>Share your profile to distribute projects with an online professional to plan, coordinate and discuss.</p>

                <div className="upload-files">
                  <div className="upload-icon">📤</div>
                  <div className="upload-title">Upload Files</div>
                  <div className="upload-description">Flash drive or mp3 file can be uploaded.</div>
                  <button className="publish-btn">Publish Now</button>
                </div>
              </div>

              {/* <div className="projects-section">
          <h3>All My Projects</h3>
          <p>Here you can find more details about your projects. Keep you user engaged by providing meaningful information.</p> */}

              {/* <div className="projects-list">
            {projects.map(project => (
              <div key={project.id} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="project-info">
                  <h5 className='text-font'>{project.title}</h5>
                  <div className="project-meta">Project #{project.id}</div>
                  <a href={`/projects/${project.id}`} className="project-details-link">
                    See project details
                  </a>
                </div>
              </div>
            ))}
          </div> */}


              <div className="projects-container">
                <h2 className="title">All My Projects</h2>
                <p className="subtitle">
                  Here you can find more details about your projects. Keep your user engaged by providing meaningful information.
                </p>

                <div className="projects-list">
                  {projects.map((project) => (
                    <div key={project.id} className="project-card">
                      <img src={project.image} alt={project.title} className="project-image" />
                      <div className="project-info">
                        <h3 className="project-title">{project.title}</h3>
                        <p className="project-number">{project.number} • <a href="#">See project details</a></p>
                      </div>
                      <button className="edit-button"> <svg viewBox="0 0 24 24" width="20" height="20">
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#888" />
                      </svg></button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default Logout
